module.exports = __webpack_public_path__ + "static/media/cafe24-waiting.efed30e7.png";